import { InjectionToken } from "@angular/core";
import { IPaxmanService } from "./paxman-service.interface";

export const PAXMAN_SERVICE = new InjectionToken<IPaxmanService>(
  'PAXMAN_SERVICE'
);
